export class CrudAnsoegningInputModel {
    constructor(brugerId: string, brugerMaalbeskrivelseId: string) {
        this.brugerId = brugerId;
        this.brugerMaalbeskrivelseId = brugerMaalbeskrivelseId;
    }
    public brugerId: string;
    public brugerMaalbeskrivelseId: string;
}
